export const getters = {
    list: state => state.list,
    // dateList: state => state.dateList,
    
    columns: state => state.columns,
    model: state => state.model,
    filter: state => state.filter,
    pagination: state => state.pagination,
    sort: state => state.sort,
    rules: state => state.rules,
};
